import { Toaster } from "./components/ui/toaster";
// DELETE THE SONNER IMPORT LINE
import { TooltipProvider } from "./components/ui/tooltip"; 
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import HistoryPage from "./pages/HistoryPage";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/history" element={<HistoryPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        {/* <Sonner /> IS NOW DELETED */}
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;